<template>
	<div :class="['dr-launcher-menu-children-container', 'pa-5', {'dr-launcher-menu-children-container-samll-screen-height' : isSmallScreen, 'dr-launcher-menu-children-container-height': !isSmallScreen}]"> 
		<div v-for="(item, index) in items" :key="index" class="dr-launcher-menu-children-item d-flex flex-column">
			<div class="dr-launcher-menu-children-folder-caption dr-launcher-menu-children-caption align-center">
        <div class="d-flex align-center">
          <div class="dr-launcher-menu-children-svg-container">
            <dr-svg v-if="item" :image="item.image || item.children[0].image || defaultSvg" :color="iconColor" :size='iconSize'></dr-svg>
          </div>
          <div class="dr-launcher-menu-children-text-container">
            {{item.name}}
          </div>
        </div>
      </div>
			<div v-for="(child, childIndex) in item.children" :key="childIndex" class="d-inline-flex  dr-launcher-child-text-container" style="width:266px">
				<div class="d-flex align-center">
					<div class="dr-launcher-menu-child d-inline-flex" @click="openInRmd(child)" @contextmenu="openContextMenu(child, $event)">
            <v-tooltip bottom open-delay="500">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">{{ child.name }}</div>
              </template>
              <span>{{ child.name }}</span>
            </v-tooltip>
          </div>
					<div class="dr-launcher-child-icon-container d-none align-center" @click="openRMDInNewTab(child)">
						<v-icon size="18px" class="material-icons">md mdi-open-in-new</v-icon>
					</div>
				</div>
			</div>
		</div>
    <context-menu v-model="showContextMenu" :x="x" :y="y" :isAppInIFrame="isAppInIFrame" :itemHaveInFavorite="itemHaveInFavorite" @openInNewTab="openInNewTab" @toShare="toShare" @addToFavorite="addToFavorite" @removeFromFavorite="removeFromFavorite" @openRenameDialog="openRenameDialog"></context-menu>
    <share-dialog v-model="showShareDialog" :pathText="fullPathText" :pathUrl="fullPathUrl" @closeDialog="closeDialog"></share-dialog>
    <rename-dialog v-model="showRenameDialog" @closeDialog="closeDialog" :caption="caption" @renameFunctionMenu="renameFunctionMenu"></rename-dialog>
  </div>
</template>
<script>
import drSvg from './dr-svg.vue'
import contextMenuMixin from '@/mainMenuSrc/mixins/contextMenuMixin'

export default {
  props: ['items', 'baseUrl', 'isAppInIFrame', 'itemHaveInFavorite'],
  mixins: [contextMenuMixin],
  components: {
    drSvg,
    'context-menu': () => import('../dialogs/contextMenu.vue'),
    'share-dialog': () => import('../dialogs/shareDialog.vue'),
    'rename-dialog': () => import('../dialogs/renameDialog.vue')
  },
  data: () => ({
    basePath: process.env.VUE_APP_BASE_PATH,
    defaultSvg: 'IT',
    iconColor: 'rgb(var(--md-pallete-rgb-400))',
    ops: {
      bar: {
        background: '#000000'
      },
      scrollPanel: {
        scrollingY: false,
        initialScrollX: true
      }
    },
    iconSize: 20
  }),
  computed: {
    isSmallScreen() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md
    }
  },
  methods: {
    openInRmd(item) {
      if (this.isFolder(item)) {
        return
      }
      let menuObject = {codeMenu: item.codeMenu,
        shareParams: item.shareParams,
        ...(item.httpLink && { httpLink: item.httpLink }) // если в item есть httpLink
      }
      this.$emit('changedCode', menuObject)
      this.$emit('closeDialog', false)
    },
    openRMDInNewTab(item) {
      if (!item) {
        return
      }
      if (item.httpLink) {
        window.open(item.httpLink)
        return
      }
      window.open(`${this.baseUrl}/?${item.shareParams}`)
    },
    isFolder(item) {
      return !item.shareParams || item.isFolder || (item.children && item.children.length)
    }
  }
}
</script>
<style>
.dr-launcher-menu-children-text-container {
  color: #000000;
  white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.dr-launcher-menu-children-svg-container {
  width: 20px;
  min-width: 20px;
  height: 20px;
  min-height: 20px;
  padding: 5px 18px;
  box-sizing: unset;
}
.dr-launcher-menu-children-container {
	overflow:auto;
	width: 100%;
	display: flex;
	writing-mode: vertical-lr;
	flex-wrap: wrap;
	align-content: flex-start;
  margin-right: var(--main-menu-width) !important;
}
.dr-launcher-menu-children-container-height {
  height: calc(100vh - var(--top-toolbar-height));
}
.dr-launcher-menu-children-container-samll-screen-height {
  height: calc(100vh - var(--top-toolbar-height));
}
.dr-launcher-menu-children-item {
	max-width: 360px;
	padding: 10px;
	writing-mode: horizontal-tb;
}

.dr-launcher-menu-children-folder-caption {
	font-size: 1em;

}
.dr-launcher-menu-children-caption {
	color: rgba(0, 0, 0);
	font-weight: 400;
	font-family: Roboto, sans;
}
.dr--launcher-menu-children-label-child-icon
{
	transition: 0.5s;
	background-color: rgb(238, 238, 238);
}

.dr-launcher-child-text-container {
	max-width: 266px;
	font-size: 0.9em;
	line-height: 1.3em;
	color: rgba(0, 0, 0, 0.8);
	cursor: pointer;
  position: relative;
  padding-right: 23px;
}


.dr-launcher-child-text-container:hover {
	background-color: rgb(238, 238, 238);
}
.dr-launcher-child-text-container:hover .dr-launcher-child-icon-container {
	display: flex !important;
}

.dr-launcher-child-icon-container {
	border-top-right-radius: 2px;
	border-bottom-right-radius: 2px;
  height: 100%;
  color: #000000de;
  position: absolute;
  right: 0px;
  background-color: #fff;
}

.dr-launcher-child-icon-container:hover {
	transition: 0.5s;
	background-color: rgb(238, 238, 238);
}
.dr-launcher-menu-child {
  padding: 5px 0px 5px 57px;
  white-space: pre-wrap;
  overflow: hidden;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  color: #000000de;
}

.dr-launcher-treeview .v-treeview-node__root:before {
  background-color: transparent;
}

</style>